import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyHourScreen from './happyHour';
import DrinksScreen from './drinks';
import BakeryScreen from './bakery';



import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import translate from '../../helpers/translate';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
        const [dataDish, setDataDish] = useState(false); 
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [visibleMenu, setvisibleMenu] = useState(true);
    const [dataapptizers, setdataapptizers] = useState(false);
    const [dataOysters, setdataOysters] = useState(false);
    const [fatherdata, setfatherdata] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showBakery, setShowBakery] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 252) {
                setdataapptizers(item.menus);
            }

            if (item.id === 631) {
                setfatherdata(item);
            }
        });
    }, [menus]);


    useEffect(() => {
        if (dataapptizers) {
            dataapptizers.map((item) => {
                if (item.id === 4985) {
                    setdataOysters(item);
                }
            });
        }
    }, [dataapptizers]);


   



    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setvisibleMenu(false);
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            getInitData();
            const scrollDiv = document.getElementById("mi-scroll-container");
            if (scrollDiv) {
                // reinicia la posición de scroll
                scrollDiv.scrollTop = 0;
            }

        } else if (document.visibilityState === "visible") {
            setvisibleMenu(true);
            const scrollDiv = document.getElementById("mi-scroll-container");
            if (scrollDiv) {
                // reinicia la posición de scroll
                scrollDiv.scrollTop = 0;
            }
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

        window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={false} setShowSpecials={setShowSpecials}>
                <div>
                    <div style={{
                        width: '100vw',
                        position: 'relative',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        position: 'absolute',
                        zIndex: 900,
                        top: 1
                    }}>
                        <video
                              src={require('./assets/sparks_bajo.mp4')}
                             loop autoPlay={true} muted 
                            style={{
                                width: '100%',
                                height: 260,
                                objectFit: 'cover',
                                borderRadius: 0,
                            }}
                        />
                    </div>
                    <div style={{ position: 'relative', zIndex: 900, marginTop:  -50}}>
                        <center>
                             <img
                             onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: 720,
                                height: 200,
                                justifyContent: 'center',
                                objectFit: 'contain',
                                zIndex: 100,
                                alignSelf: 'center',
                                  pointerEvents: 'none',
                                   marginTop: 0,
                                
                            }}
                            src={require('./assets/logo-voraz-png.png')}
                        />
                        </center>
                    </div>
                <div style={{display: 'flex', width: '100%', marginTop: -20, position: 'relative',zIndex: 100}}>
                     <div style={{ width: '50%' }}>
                        <video
                            src={require('./assets/VORAZIPAD_1.mp4')}
                            loop autoPlay={true} muted 
                                style={{
                                marginTop: 40,
                                width: 300,
                                height: 540,
                                objectFit: 'cover',
                                borderRadius: 14,
                                marginTop: 52,
                            }}
                        />

                    </div>
                    <div style={{ width: '50%', paddingLeft: 12, paddingTop: 30 }}>
                            {visibleMenu && <div id="mi-scroll-container" style={{ height: 610, overflow: 'scroll' }}>
                                
                                 <div
                                                onClick={() => {
                                                setShowHappy(true)
                                                    
                                                }}
                                                style={{
                                                    width: '100%',
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center', width: '100%',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn_plata_alta.png')} style={{
                                                            width: '100%',
                                                        height: 100,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'black',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                          Cócteles - Cocktails
                                                        </p>
                                                </div>
                                            
                            </div>
                            <div
                                style={{
                                   
                                    display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                            }}>
                                {menus.map((item, key) => {
                                    if (item.id != 705 && item.id != 706 && item.id != 707 && item.id != 708 && item.id != 669 && item.id != 670 && item.id != 671 && item.id != 672 && item.id != 673 && item.id != 674 && item.id != 675 && item.id != 676 && item.id != 677) {
                                        return (
                                            <div
                                                onClick={() => {

                                                    if (item.id === 342) {
                                                        setShowHappy(true)
                                                    }else if (item.id === 343) {
                                                        SetshowExecutiveMenu(true)
                                                    } else if (item.id === 713) {
                                                        setShowDrinks(true)
                                                    }
                                                    else if (item.id === 714) {
                                                        setShowBakery(true)
                                                    }
                                                    else {
                                                        setShowListProduct(true)
                                                        setdishs(item)
                                                    }
                                                }}
                                                style={{
                                                    width: '100%',
                                                    height: 85,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22,
                                                  
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                            width: '100%',
                                                        height: 100,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                           { translate('es', item.language, item.name)} / { translate('en', item.language, item.name)}
                                                        </p>
                                                </div>
                                            
                                            </div>
                                        );
                                    }
                                })}
                                </div>
                                
                               
                            </div>}
                            

                           
                      
                        </div>
                </div>
               
            </div>
           

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showDrinks && <DrinksScreen setShowHappy={setShowDrinks} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            {showBar && <BarScreen setShowBar={setShowBar} />}
            {showBakery && <BakeryScreen setShowHappy={setShowBakery} />}
            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
            </LayoutContent>
            </div>
    );
}

export default Index;